import { render, staticRenderFns } from "./fodera.vue?vue&type=template&id=470a1995&"
import script from "./fodera.vue?vue&type=script&lang=js&"
export * from "./fodera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports